import React from 'react';
import styles from '../../../styles/DashboardStyles/Header.module.css';
import menu from "./assets/menu.png"
import profile from './assets/profile.png';


const Header = ({ userData, toggleMenu, openNotifyModal, openProfileModal, toggleMobileSidebar }) => {
    console.log(userData);
    console.log("header")
    return (
        <div className={styles.header}>
            <div className={styles.left}>
                <div className={styles.menugrid} onClick={toggleMenu}>
                    {/* <img src={menu} alt="Menu" /> */}
                </div>
                <div
                    className={styles.mobileMenugrid}
                    onClick={toggleMobileSidebar}
                >
                    <img src={menu} alt="Menu" />
                </div>
            </div>
            <div className={styles.right}>
                <div
                    onClick={openProfileModal}
                    className={styles.profile}>
                    <img src={userData?.photoUrl || profile} alt="Profile" />
                </div>
            </div>
        </div>
    );
};

export default Header;
